angular.module('cvsApp').service('refreshTokenService', ['networkService', 'xdrService', 'configManager',
    'refreshTokenModel', 'cvsAppData', function (NS, XS, CM, TEM, CAD) {

        function refreshToken() {
            this.refreshToken = function (callBackSuccess, orefreshToken, callback) {
                var apikey = CAD.getApiKey();
                 var params = "&tokenID=" + orefreshToken + "&tokenType=Login";
                 var url = CM.getApiUrlWithApikeyAndAppName('REFRESH_TOKEN', cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB') + params;
                 var plainUrl = CM.getPlainApiUrl(url);
                if (url === "URL_ERROR") {

                } else {
                    var request = {
                        url: plainUrl,
                        header: {
                            'Content-Type': 'application/json',
                            'accept': 'application/xml'
                        },
                        data: requestBody(url),
                        onSuccess: callBackSuccess
                    }
                    //cvsUtility.commonServiceCode(url, "refreshToken", TEM, request, callBackSuccess, NS);
                    if (cvsUtility.getIEVersion() <= 9) {
                        XS.makeRequest(url, requestBody(url), xdrSuccess);

                        function xdrSuccess(data) {
                            TEM.setResponse(data.data);
                            callBackSuccess(TEM.getResponse(), callback);
                        }
                    } else {
                        var promise = NS.post(request);
                        promise.then(function (data) {
                            TEM.setResponse(data.data);
                            callBackSuccess(TEM.getResponse(), callback);
                        }, function (reason) {
                            callBackSuccess(NS.httpError(reason));
                        });
                    }
                }
            }

            var requestBody = function(entities){
                var requestJson = { serviceParams: CM.getModifiedParams(entities) };
                return requestJson;
            };
        }

        return new refreshToken();
    }]);